__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mattermost-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hello-pangea/dnd", "18.0.1", () => (Promise.all([__webpack_require__.e(6579), __webpack_require__.e(1424), __webpack_require__.e(9648), __webpack_require__.e(2803), __webpack_require__.e(3456)]).then(() => (() => (__webpack_require__(6579))))));
			register("@mattermost/client", "12.0.0", () => (Promise.all([__webpack_require__.e(8246), __webpack_require__.e(7569)]).then(() => (() => (__webpack_require__(37569))))));
			register("history", "4.10.1", () => (__webpack_require__.e(8844).then(() => (() => (__webpack_require__(78844))))));
			register("luxon", "3.6.1", () => (__webpack_require__.e(8944).then(() => (() => (__webpack_require__(78944))))));
			register("react-bootstrap", "github:mattermost/react-bootstrap#d693ec8082954f0e6d3e826ca6161979b29001cd", () => (Promise.all([__webpack_require__.e(5757), __webpack_require__.e(2967), __webpack_require__.e(1424), __webpack_require__.e(9648), __webpack_require__.e(9848)]).then(() => (() => (__webpack_require__(22967))))));
			register("react-dom", "19.2.8", () => (Promise.all([__webpack_require__.e(1424), __webpack_require__.e(6174)]).then(() => (() => (__webpack_require__(26174))))));
			register("react-intl", "*", () => (Promise.all([__webpack_require__.e(10), __webpack_require__.e(1424)]).then(() => (() => (__webpack_require__(90010))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(1899), __webpack_require__.e(1424)]).then(() => (() => (__webpack_require__(51899))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(8233), __webpack_require__.e(1424), __webpack_require__.e(9366)]).then(() => (() => (__webpack_require__(78233))))));
			register("react", "19.2.8", () => (__webpack_require__.e(2963).then(() => (() => (__webpack_require__(62963))))));
			register("styled-components", "5.3.7", () => (Promise.all([__webpack_require__.e(4776), __webpack_require__.e(1424), __webpack_require__.e(541)]).then(() => (() => (__webpack_require__(44776))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};